import Autosuggest from 'react-autosuggest'
import { useState, useRef, useMemo } from 'react'
import { useIntl } from 'react-intl'
import debounce from 'lodash/debounce'
import API from 'api'

const renderSuggestion = (suggestion, fieldLabel) => {
  if(!suggestion[fieldLabel].length) {
    return ''
  }

  return (
    <div className={`typeahead-item ${suggestion.last ? 'last' : ''}`}>
      {suggestion[fieldLabel]}
    </div>
  )
}

export default function AutosuggestInput({
  input,
  onSuggestionSelect = () => {},
  disabled,
  url,
  label,
  placeholder,
  fieldId = 'id',
  fieldLabel = 'title',
  queryParams = {},
}) {
  const controller = useRef()
  const signal = useRef()
  const intl = useIntl()
  const [value, setValue] = useState('')
  const [suggestions, setSuggestions] = useState([])

  const getSuggestionValue = (suggestion) => {
    onSuggestionSelect(suggestion)
    input.onChange(suggestion[fieldId])
    return suggestion[fieldLabel]
  }

  const onSuggestionsFetchRequested = debounce(({ value }) => {
    if(controller.current !== undefined) {
      // Cancel the previous request
      controller.current.abort()
    }

    if('AbortController' in window) {
      controller.current = new window.AbortController()
      signal.current = controller.current.signal
    }

    return API(url, signal.current)
      .get({
        search: value,
        ...queryParams,
      })
      .then((items) => {
        setSuggestions(items.results || items)
      })
  }, 300)

  // Autosuggest will call this function every time you need to clear suggestions.
  const onSuggestionsClearRequested = () => {
    setSuggestions([])
  }

  const onChange = (_, { newValue }) => {
    setValue(newValue)
    // if(newValue.length === 0) {
    //   onSuggestionsClearRequested()
    //   onSuggestionSelect({
    //     place_id: undefined,
    //     shop_id: undefined,
    //     organiser_pk: undefined,
    //     organiserTitle: undefined,
    //     near_by: undefined,
    //   })
    // }
  }

  const onFocus = (e) => {
    try {
      e.currentTarget.setSelectionRange(0, value.length)
    } catch (err) {
      // Non IOs option if not supported, e.g. Chrome
      e.currentTarget.select()
    }
  }

  const inputProps = useMemo(
    () => ({
      placeholder:
        typeof placeholder === 'object'
          ? intl.formatMessage(placeholder)
          : placeholder,
      value,
      type: 'search',
      autoComplete: 'off',
      disabled,
      onChange,
      onFocus,
    }),
    [value, disabled]
  )

  return (
    <div>
      <label>{label}</label>
      <Autosuggest
        suggestions={suggestions}
        disabled={disabled}
        onSuggestionsFetchRequested={onSuggestionsFetchRequested}
        onSuggestionsClearRequested={onSuggestionsClearRequested}
        getSuggestionValue={getSuggestionValue}
        renderSuggestion={(suggestion) =>
          renderSuggestion(suggestion, fieldLabel)
        }
        inputProps={inputProps}
      />
    </div>
  )
}
